// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Box, Toolbar } from '@mui/material';
import ErrorWrapper from '../components/ErrorWrapper';
import { HeaderContent } from '../components/Header/HeaderContent';
import { useBranding } from '../contexts/BrandingContext';

export const Header: React.FC = () => {
  const { branding } = useBranding();

  return (
    <ErrorWrapper>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
        <AppBar position="fixed">
          <Toolbar>
            {branding.headerLogo}
            <HeaderContent />
          </Toolbar>
        </AppBar>

        <Box sx={{ marginTop: 8, height: '100%', overflow: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </ErrorWrapper>
  );
};
